var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBanner03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "#ffffff",
      display: "block",
      zIndex: 1,
      position: "relative"
    },
    width: 1365,
    height: 414,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1365 414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(682.5,207) scale(1,1) translate(-682.5,-207)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg-0.1922329122939992",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0b65c6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0b65c6",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.1922329122939992)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "0s",
    values: "M0 0M 0 340.6308584826279Q 227.5 501.158813694847 455 492.484014366234T 910 514.4005028636138T 1365 336.3179793862639L 1365 78.3598569093665Q 1137.5 70.37983725864683 910 69.29561948071512T 455 57.448527310719555T 0 -71.72174399808046Z;M0 0M 0 571.3595679067556Q 227.5 480.3666436213049 455 471.83376424547026T 910 490.78279068831273T 1365 533.4389247781276L 1365 -125.92770135923075Q 1137.5 -53.25910454259692 910 -54.219383638016836T 455 23.63078595442377T 0 74.82530869897303Z;M0 0M 0 450.42121472148676Q 227.5 547.2647077906882 455 543.0230339544413T 910 412.8691665741978T 1365 578.2785305496839L 1365 -155.98392035260184Q 1137.5 -66.18029566926225 910 -72.11020353768981T 455 32.01514890842364T 0 -160.52965143927986Z;M0 0M 0 340.6308584826279Q 227.5 501.158813694847 455 492.484014366234T 910 514.4005028636138T 1365 336.3179793862639L 1365 78.3598569093665Q 1137.5 70.37983725864683 910 69.29561948071512T 455 57.448527310719555T 0 -71.72174399808046Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.1922329122939992)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-2.5s",
    values: "M0 0M 0 329.132400774571Q 227.5 503.87076133301423 455 497.9141127831278T 910 380.8051884188694T 1365 500.73935271245324L 1365 48.20492318482579Q 1137.5 3.6210760306039917 910 -1.3036651496978209T 455 32.20532536926663T 0 -156.16675868683598Z;M0 0M 0 381.92370670934486Q 227.5 568.2576750029857 455 560.7874933696842T 910 474.66179238540167T 1365 577.1634527654041L 1365 46.91014683060328Q 1137.5 -135.39444949211233 910 -139.6011610802052T 455 41.29732591087438T 0 -81.38301030200631Z;M0 0M 0 384.53961750396275Q 227.5 336.3503853642766 455 328.76462615375044T 910 503.5777344333019T 1365 514.5497342744559L 1365 98.78771100295766Q 1137.5 28.95228760242741 910 25.87336071453501T 455 -85.96745063893849T 0 17.15216542624171Z;M0 0M 0 329.132400774571Q 227.5 503.87076133301423 455 497.9141127831278T 910 380.8051884188694T 1365 500.73935271245324L 1365 48.20492318482579Q 1137.5 3.6210760306039917 910 -1.3036651496978209T 455 32.20532536926663T 0 -156.16675868683598Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.1922329122939992)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-5s",
    values: "M0 0M 0 402.2425070994493Q 227.5 427.75812921109645 455 426.85094560329674T 910 527.7035285132235T 1365 502.83398916678686L 1365 -133.35098226058693Q 1137.5 -132.52363047460642 910 -141.81121022756668T 455 33.92008488731531T 0 -20.713032273417156Z;M0 0M 0 347.38889490451373Q 227.5 451.47498184487404 455 444.39704887767823T 910 574.4974386231988T 1365 338.7315993562212L 1365 -98.85792750558551Q 1137.5 -104.33924168653658 910 -110.60894930223287T 455 14.849084888508969T 0 52.712742837291785Z;M0 0M 0 437.1409810477269Q 227.5 442.9091437847511 455 435.65798944129654T 910 498.61164372388635T 1365 502.2399376614244L 1365 -92.63296442312878Q 1137.5 -44.35526819258156 910 -47.79376586709827T 455 -45.59115297209104T 0 -16.384475911279168Z;M0 0M 0 402.2425070994493Q 227.5 427.75812921109645 455 426.85094560329674T 910 527.7035285132235T 1365 502.83398916678686L 1365 -133.35098226058693Q 1137.5 -132.52363047460642 910 -141.81121022756668T 455 33.92008488731531T 0 -20.713032273417156Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.1922329122939992)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-7.5s",
    values: "M0 0M 0 488.39865765875754Q 227.5 475.877270411223 455 474.85788781396315T 910 439.2851545365503T 1365 550.6875022361514L 1365 -34.1076905089995Q 1137.5 -122.31484325201126 910 -122.46659570962095T 455 -140.58541717084637T 0 -95.56747875027418Z;M0 0M 0 360.34515519042645Q 227.5 417.9978333438233 455 413.373288273369T 910 555.9596780988632T 1365 506.98569146788316L 1365 -28.949322022861793Q 1137.5 -128.64073064238687 910 -137.10118957346617T 455 6.700572978394689T 0 36.51043190456832Z;M0 0M 0 338.97893171845715Q 227.5 437.0542982214511 455 431.0917684495815T 910 541.2550875106092T 1365 536.2929526999887L 1365 -11.516316805219617Q 1137.5 -49.98888399282847 910 -54.227197798825955T 455 57.2935297848976T 0 22.171009809453608Z;M0 0M 0 488.39865765875754Q 227.5 475.877270411223 455 474.85788781396315T 910 439.2851545365503T 1365 550.6875022361514L 1365 -34.1076905089995Q 1137.5 -122.31484325201126 910 -122.46659570962095T 455 -140.58541717084637T 0 -95.56747875027418Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner03);
export default __webpack_public_path__ + "static/media/banner03.a278a430daff7d7a2a6ecadf07fc902b.svg";
export { ForwardRef as ReactComponent };